var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._t("default"),_vm._v(" "),_c('error-controller'),_vm._v(" "),_c('notification-controller'),_vm._v(" "),_c('vehicle-notification-controller')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }